import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { Resource } from '../../../../../index';
import { LanguageContext } from "../../../../../context/LanguageContext";
import BotaoComIconePadrao from "../BotaoComIconePadrao";

const DocumentContainer = styled.div`
    transition: background 0.3s ease;

    &:hover {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        background: #e1effd;
    }
`;

export interface ISelectedFile {
    nomeDoDocumento: string;
    versaoDoDocumento: string;
    dataVencimento: string;
    desabilitarVigencia: boolean;
    tamanhoDeArquivo: number;
    nomeDoArquivo: string;
}

export const InputFile = ({ onChange, enviarValores }) => {
    const { getLanguageResource } = useContext(LanguageContext);
    const [arquivosSelecionados, setArquivosSelecionados] = useState<ISelectedFile[]>([]);

    const maxFileSize = 28 * 1024 * 1024; // 28MB

    const handleSelectFile = (_event) => {
        const input = document.querySelector("input[type=file]") as HTMLInputElement;
        input.click();
    };

    const handleUploadFile = (event) => {
        const files = event.target.files;
        const filesArray = Array.from(files) as File[];
        onChange(event.target.files && event.target.files?.length > 0 ? event.target.files : undefined);

        filesArray.forEach((file: File) => {
            const fileName = file.name;
            const fileSize = file.size;
            const fileVersion = getLanguageResource('first_version');
            const fileExpiryDate = '';

            setArquivosSelecionados((prevState) => [
                ...prevState,
                {
                    nomeDoDocumento: fileName,
                    versaoDoDocumento: fileVersion,
                    dataVencimento: fileExpiryDate,
                    desabilitarVigencia: false,
                    tamanhoDeArquivo: fileSize,
                    nomeDoArquivo: fileName,
                },
            ]);
        });
    };

    const handleChange = (event, propriedade) => {
        event.target.classList.remove('is-invalid');
        
        setArquivosSelecionados((prevState) => {
            const updatedFiles = prevState.map((item) => {
                if (event.target.id === propriedade + "-" + item.nomeDoArquivo) {
                    return { ...item, [propriedade]: event.target.value };
                }
                return item;
            });
            return updatedFiles;
        });
    };

    useEffect(() => {
        enviarValores(arquivosSelecionados);
    }, [arquivosSelecionados]);

    const handleIconFile = (file) => {
        const bootstrapIconsExtensions = ["aac", "ai", "bmp", "cs", "css", "csv", "doc", "docx", "exe", "gif", "heic", "html", "java", "jpg", "js", "json", "jsx", "key", "m4p", "md", "mdx", "mov", "mp3", "mp4", "otf", "pdf", "php", "png", "ppt", "pptx", "psd", "py", "raw", "rb", "sass", "scss", "sh", "sql", "svg", "tiff", "tsx", "ttf", "txt", "wav", "woff", "xls", "xlsx", "xml", "yml"];
        const fileExtension = file.slice(file.lastIndexOf('.') + 1) as string;

        if (bootstrapIconsExtensions.includes(fileExtension)) {
            return `bi bi-filetype-${fileExtension}`;
        }

        return 'bi bi-file-earmark';
    };

    const dateMin = (): string => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const year = tomorrow.getFullYear();
        const month = tomorrow.getMonth() + 1;
        const day = tomorrow.getDate();

        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const handleDisableVigencia = (desabilitar, file) => {
        const input = document.getElementById("dataVencimento-" + file.nomeDoArquivo) as HTMLInputElement;
        input.classList.remove('is-invalid');

        setArquivosSelecionados((prevState) => {
            const updatedFiles = prevState.map((item) => {
                if (item.nomeDoArquivo === file.nomeDoArquivo) {
                    return { ...item, desabilitarVigencia: desabilitar, dataVencimento: desabilitar ? '' : item.dataVencimento };
                }
                return item;
            });
            return updatedFiles;
        });
    }

    return (
        <>
            <div className="d-flex align-itens-center flex-column">
                <div className="d-flex flex-column align-items-center overflow-auto" style={{ maxHeight: '70vh', width: '100%' }}>
                    {
                        arquivosSelecionados.length > 0
                            ? arquivosSelecionados.map((arquivoSelecionado, index) => (
                                <DocumentContainer className="d-flex align-items-center border rounded p-2 m-1 w-100" key={arquivoSelecionado.nomeDoArquivo}>
                                    {
                                        (arquivoSelecionado.nomeDoDocumento !== getLanguageResource('no_file_selected')) && (
                                            <div className="d-flex flex-column align-items-start w-100">
                                                <div className="d-flex align-items-end w-100 justify-content-between">
                                                    {
                                                        (arquivoSelecionado.nomeDoDocumento !== getLanguageResource('no_file_selected') && !(arquivoSelecionado.tamanhoDeArquivo > maxFileSize)) && (
                                                            <>
                                                                <i className={`${handleIconFile(arquivoSelecionado.nomeDoArquivo)} text-center`} style={{ fontSize: '2rem' }}></i>
                                                                <i className="text-truncate mx-2" style={{ fontSize: '1.2rem' }}>{arquivoSelecionado.nomeDoArquivo}</i>
                                                            </>
                                                        )

                                                    }
                                                    {
                                                        arquivoSelecionado.tamanhoDeArquivo > maxFileSize && (
                                                            <div className="d-flex align-items-center">
                                                                    <i className="bi bi-exclamation-octagon text-warning m-2" style={{ fontSize: '2rem' }}></i>
                                                                    <div className="d-flex flex-column">
                                                                        <i className="text-truncate">{arquivoSelecionado.nomeDoArquivo}</i>
                                                                        <h6 className='text-truncate mb-0'>{getLanguageResource('size_limit_exceeded')}</h6>
                                                                    </div>
                                                            </div>
                                                        )
                                                    }
                                                    <BotaoComIconePadrao
                                                        title="Remover"
                                                        classeDeIcone="bi bi-trash"
                                                        corDoIcone="#dd0000"
                                                        onClick={() => {
                                                            setArquivosSelecionados((prevState) => prevState.filter((_, i) => i !== index));
                                                        }}
                                                        style={{ width: '2rem', height: '2rem' }}
                                                        type="button"
                                                    />
                                                </div>
                                                {
                                                    !(arquivoSelecionado.tamanhoDeArquivo > maxFileSize) && (
                                                        <div className="d-flex flex-column w-100 border-top pt-2 mt-2">
                                                            <label className='text-truncate mb-0'>{getLanguageResource('document_name')}</label>
                                                            <input type="text" name='nomeDoDocumento' id={"nomeDoDocumento-" + arquivoSelecionado.nomeDoArquivo} className='form-control' onChange={(e) => handleChange(e, "nomeDoDocumento")} value={arquivoSelecionado.nomeDoDocumento} required />
            
                                                            <label className='text-truncate mb-0 mt-1'>{getLanguageResource('version')}</label>
                                                            <input type="text" name='versaoDoDocumento' id={"versaoDoDocumento-" + arquivoSelecionado.nomeDoArquivo} className='form-control' onChange={(e) => handleChange(e, "versaoDoDocumento")} value={arquivoSelecionado.versaoDoDocumento} required />
            
                                                            <label className='text-truncate mb-0 mt-1'>{getLanguageResource('expiry_date')}</label>
                                                            <input disabled={arquivoSelecionado.desabilitarVigencia} type="date" name='dataVencimento' id={"dataVencimento-" + arquivoSelecionado.nomeDoArquivo} min={dateMin()} max={'9999-12-31'} className='form-control' onChange={(e) => handleChange(e, "dataVencimento")} value={arquivoSelecionado.dataVencimento} required />
            
                                                            <div className="custom-control custom-checkbox">
                                                                <input type="checkbox" className="custom-control-input" id={"toggleVigencia-" + arquivoSelecionado.nomeDoArquivo} onChange={(e) => handleDisableVigencia(e.target.checked, arquivoSelecionado)} checked={arquivoSelecionado.desabilitarVigencia} />
                                                                <label className="custom-control-label" htmlFor={"toggleVigencia-" + arquivoSelecionado.nomeDoArquivo}>{getLanguageResource("disable_term")}</label>
                                                            </div>
                                                            {
                                                                arquivoSelecionado.dataVencimento.length > 0 && new Date(arquivoSelecionado.dataVencimento) < new Date() && (
                                                                    <p className='text-danger'>{getLanguageResource('invalid_date')}</p>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </DocumentContainer>
                            ))
                            : null
                    }
                </div>
                {
                    arquivosSelecionados.length === 0 && (
                        <>
                            <h6 className="text-center my-5">{getLanguageResource('no_file_selected')}</h6>
                            <button type="button" className="btn ws-outline-blue mb-1" id='botaoDeUpload' onClick={handleSelectFile}>{getLanguageResource('select_file')}</button>
                        </>
                    )
                }
                {
                    arquivosSelecionados.length > 0 && (
                        <button type="button" className="btn ws-outline-blue mb-1" id='botaoDeUpload' onClick={handleSelectFile}>{getLanguageResource('add_files')}</button>
                    )
                }
                <label><i>{<Resource keyString="maximum_file_size_28MB" />}</i></label>
            </div>
            <input type="file" className="d-none" onChange={handleUploadFile} multiple />
        </>
    );
};
